import PageLayout from "../../../../components/page/PageLayout";
import CartReview from "../cart/stage/CartReview";
import {useState} from "react";
import CartCheckout from "../cart/stage/CartCheckout";
import DialogLoading from "../../general/dialog/DialogLoading";
import CartConfirmation from "../cart/stage/CartConfirmation";
import CartEmpty from "../cart/stage/CartEmpty";
import useCheckoutStore from "../../../cart/store/checkoutStore";
import useValueChangeListener from "../../../services/state/general/useValueChangeListener";
import useSession from "../../../services/state/session/useSession";

const REVIEW = "R";
const CHECKOUT = "C";
const AFTER_CHECKOUT = "AF";

const EmptySwitcher = ({children}) => {

    const count = useCheckoutStore(state => state.products?.lines?.length);
    const hasProducts = count > 0;

    if(hasProducts) {
        return <>{children}</>
    } else {
        return <CartEmpty />
    }
}

const Prepare = ({ children }) => {

    const session = useSession();
    const loading = useCheckoutStore(state => state.loading?.prepareCheckout);
    const prepareCart = useCheckoutStore(state => state.prepareCheckout);

    useValueChangeListener(() => prepareCart(session), [1], [])

    return (
        <>
            <DialogLoading loading={loading} message={"Preparing Cart"} />
            <div
                style={{
                    filter: loading ? "blur(4px)" : "none",
                    pointerEvents: loading ? "none" : "auto",
                    transition: "filter 0.2s ease"
                }}
            >
                {children}
            </div>
        </>
    )
}

const ThePage = () => {

    const completedOrder = useCheckoutStore(state => state.completedOrder);
    const orderIsComplete = false;
    const [ cartState, setCartState ] = useState(orderIsComplete ? AFTER_CHECKOUT : REVIEW);

    return (
        <Prepare>
            {completedOrder &&
                <CartConfirmation completedOrder={completedOrder} />
            }
            {!completedOrder &&
                <EmptySwitcher>
                    {cartState === REVIEW &&
                        <CartReview onNext={() => setCartState(CHECKOUT)} />
                    }
                    {cartState === CHECKOUT &&
                        <CartCheckout />
                    }
                </EmptySwitcher>
            }
        </Prepare>
    )
}

const PageCartReview = () => {

    return (
        <PageLayout requireSignIn={true}>
            <ThePage />
        </PageLayout>
    )
}

export default PageCartReview;
